"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __spreadArrays = this && this.__spreadArrays || function () {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) {
    s += arguments[i].length;
  }

  for (var r = Array(s), k = 0, i = 0; i < il; i++) {
    for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) {
      r[k] = a[j];
    }
  }

  return r;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var actionTypes_1 = require("./actionTypes");

exports.notifications = function (state, action) {
  if (state === void 0) {
    state = {
      values: []
    };
  }

  var _a;

  if (!((_a = action) === null || _a === void 0 ? void 0 : _a.data)) {
    return state;
  }

  var notificationType = action.type,
      _b = action.id,
      id = _b === void 0 ? '' : _b,
      _c = action.data,
      type = _c.type,
      data = __rest(_c, ["type"]);

  switch (notificationType) {
    case actionTypes_1.ADD_NOTIFICATION:
      return __assign(__assign({}, state), {
        values: __spreadArrays(state.values, [{
          id: id,
          type: type,
          log: [__assign(__assign({}, data), {
            timestamp: Date.now()
          })]
        }])
      });

    case actionTypes_1.UPDATE_NOTIFICATION:
      return __assign(__assign({}, state), {
        values: state.values.map(function (item) {
          return item.id !== action.id ? item : __assign(__assign({}, item), {
            log: __spreadArrays(item.log, [__assign(__assign({}, data), {
              timestamp: Date.now()
            })])
          });
        })
      });

    case actionTypes_1.REMOVE_NOTIFICATION:
      return __assign(__assign({}, state), {
        values: state.values.filter(function (item) {
          return item.id !== action.id;
        })
      });

    default:
      return state;
  }
};